<div style="margin-bottom: 20px ;">
  <app-progress-bar [indexItem]=itemNumber [progressBarState]=progressBarName [progressBarArray1]=progressBarArray1>
  </app-progress-bar>
</div>
<div class="section" *ngIf="!fromTable">

  <div class="content" style="margin: 10px 16px">
    <p class="sub-text-600-bold" style="display: inline-block;margin-top: 10px;">Extract Batch Key From Cloud</p>
  </div>
  <div class="content" style="margin: 0px 16px;padding-bottom: 21px; border-bottom: 2px solid rgba(5, 5, 5, 0.12);">
    <div style="display: inline-block; border-right: 1px solid #c4c4c4; padding-right: 20px;">
      <p class="text_12">New Batch Key</p>
      <p *ngIf="!batchKey" class="text_14">Submit saved configurations to generate a New Batch Key</p>
      <p *ngIf="batchKey" class="text_14">{{batchKey}}</p>
    </div>
    <div *ngIf="batchKey"
      style="display: inline-block; border-right: 1px solid #c4c4c4; margin-left: 20px; padding-right: 20px;min-width: 100px;">
      <p class="text_12">Status</p>
      <p *ngIf="batchKey" class="text_14">New </p>
    </div>
    <div *ngIf="batchKey" style="display: inline-block; margin-left: 20px;">
      <p class="text_12">Selected Cloud Instance</p>
      <p *ngIf="batchKey" class="text_14">{{selectedInstance?.INSTANCE}} </p>
    </div>
    <div style="float: right;">
      <button mat-flat-button class="green-button"
        style="float: right;margin-left: 40px;margin-top: 10px;min-width: 120px;" (click)="onExtractClick()"> Extract
      </button>
      <div *ngIf="!editBtnDisable"
        style="float: right;margin-right: 8px;margin-top: 10px;min-width: 120px;color: #0D8390; font-size: 12px!important;">
        <div style="display: inline-block;vertical-align: middle;margin-top: 5px;margin-right: 5px;cursor: pointer;"
          (click)="editConfig()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="11" stroke="#0D8390" stroke-width="2" />
            <path
              d="M6 15.4974V17.9971H8.49965L15.872 10.6248L13.3723 8.12511L6 15.4974ZM17.805 8.6917C18.065 8.43173 18.065 8.01179 17.805 7.75183L16.2452 6.19204C15.9853 5.93208 15.5653 5.93208 15.3054 6.19204L14.0855 7.41187L16.5852 9.91153L17.805 8.6917Z"
              fill="#0D8390" />
          </svg>
        </div> <span style="font-weight: bold; font-size: 12px;cursor: pointer" (click)="editConfig()">Edit
          Configurations</span>
      </div>
      <div *ngIf="editBtnDisable"
        style="float: right;margin-right: 8px;margin-top: 10px;min-width: 120px;color: #ADB6BF; font-size: 12px!important; cursor: no-drop;">
        <div style="display: inline-block;vertical-align: middle;margin-top: 5px;margin-right: 5px;">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="11" stroke="#ADB6BF" stroke-width="2" />
            <path
              d="M6 15.4974V17.9971H8.49965L15.872 10.6248L13.3723 8.12511L6 15.4974ZM17.805 8.6917C18.065 8.43173 18.065 8.01179 17.805 7.75183L16.2452 6.19204C15.9853 5.93208 15.5653 5.93208 15.3054 6.19204L14.0855 7.41187L16.5852 9.91153L17.805 8.6917Z"
              fill="#ADB6BF" />
          </svg>
        </div> <span style="font-weight: bold; font-size: 12px;">Edit Configurations</span>
      </div>
    </div>
  </div>



  <div class="content" style="margin: 0px 16px;">
    <div *ngFor="let item of tracks; let i = index" (click)="showArray[i]=!showArray[i]"
      style="border-bottom: 1px solid #c4c4c4; padding-top: 10px; padding-bottom: 10px;">
      <span>
        <span *ngIf="!showArray[i]"><img alt="image" src="./assets/Expand-Column.svg"
            class="expand-button"></span>
        <span *ngIf="showArray[i]"><img alt="image" src="./assets/Expand-Column-svg.svg"
            class="expand-button"></span><button mat-button>{{item}}</button>
      </span>
      <div *ngIf="showArray[i]" class="buttons-i">
        <span *ngFor="let configItem of configData">
          <ng-container *ngIf="item == configItem.TRACK">
            <span (click)="configPopUp($event, configItem)" style="display: inline-block; margin-right:32px;">
              <mat-checkbox [checked]="configItem.saveStatus" [disableRipple]="true" (click)="$event.preventDefault()">
                <span mat-button>{{configItem.APPLICATION}}</span>
              </mat-checkbox>
            </span>
          </ng-container>
        </span>
      </div>
    </div>


  </div>
</div>

<div class="section" *ngIf="fromTable">

  <div class="content" style="margin: 10px 16px">
    <p class="sub-text-600-bold" style="display: inline-block;margin-top: 10px;">Extract Batch Key From Cloud</p>
  </div>
  <div class="content" style="margin: 0px 16px;padding-bottom: 21px; border-bottom: 2px solid rgba(5, 5, 5, 0.12);">
    <div style="display: inline-block; border-right: 1px solid #c4c4c4; padding-right: 20px;">
      <p class="text_12">New Batch Key</p>
      <p *ngIf="!batchKey" class="text_14">Submit saved configurations to generate a New Batch Key</p>
      <p *ngIf="batchKey" class="text_14">{{batchKey}}</p>
    </div>
    <div *ngIf="batchKey"
      style="display: inline-block; border-right: 1px solid #c4c4c4; margin-left: 20px; padding-right: 20px;min-width: 100px;">
      <p class="text_12">Status</p>
      <p *ngIf="batchKey" class="text_14">New </p>
    </div>
    <div *ngIf="batchKey" style="display: inline-block; margin-left: 20px;">
      <p class="text_12">Selected Cloud Instance</p>
      <p *ngIf="batchKey" class="text_14">{{selectedInstance?.INSTANCE}} </p>
    </div>
    <div style="float: right;">
      <button mat-flat-button class="green-button"
        style="float: right;margin-left: 40px;margin-top: 10px;min-width: 120px;" (click)="onExtractClick()"> Extract
      </button>
      <div *ngIf="!editBtnDisable"
        style="float: right;margin-right: 8px;margin-top: 10px;min-width: 120px;color: #0D8390; font-size: 12px!important;">
        <div style="display: inline-block;vertical-align: middle;margin-top: 5px;margin-right: 5px;cursor: pointer;"
          (click)="editConfig()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="11" stroke="#0D8390" stroke-width="2" />
            <path
              d="M6 15.4974V17.9971H8.49965L15.872 10.6248L13.3723 8.12511L6 15.4974ZM17.805 8.6917C18.065 8.43173 18.065 8.01179 17.805 7.75183L16.2452 6.19204C15.9853 5.93208 15.5653 5.93208 15.3054 6.19204L14.0855 7.41187L16.5852 9.91153L17.805 8.6917Z"
              fill="#0D8390" />
          </svg>
        </div> <span style="font-weight: bold; font-size: 12px;cursor: pointer" (click)="editConfig()">Edit
          Configurations</span>
      </div>
      <div *ngIf="editBtnDisable"
        style="float: right;margin-right: 8px;margin-top: 10px;min-width: 120px;color: #ADB6BF; font-size: 12px!important; cursor: no-drop;">
        <div style="display: inline-block;vertical-align: middle;margin-top: 5px;margin-right: 5px;">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="11" stroke="#ADB6BF" stroke-width="2" />
            <path
              d="M6 15.4974V17.9971H8.49965L15.872 10.6248L13.3723 8.12511L6 15.4974ZM17.805 8.6917C18.065 8.43173 18.065 8.01179 17.805 7.75183L16.2452 6.19204C15.9853 5.93208 15.5653 5.93208 15.3054 6.19204L14.0855 7.41187L16.5852 9.91153L17.805 8.6917Z"
              fill="#ADB6BF" />
          </svg>
        </div> <span style="font-weight: bold; font-size: 12px;">Edit Configurations</span>
      </div>
    </div>
  </div>

  <div class="content" style="margin: 0px 16px;">
    <div *ngFor="let item of tracks; let i = index" (click)="showArray[i]=!showArray[i]"
      style="border-bottom: 1px solid #c4c4c4; padding-top: 10px; padding-bottom: 10px;">
      <span>
        <span *ngIf="!showArray[i]"><img alt="image" src="./assets/Expand-Column.svg"
            class="expand-button"></span>
        <span *ngIf="showArray[i]"><img alt="image" src="./assets/Expand-Column-svg.svg"
            class="expand-button"></span><button mat-button>{{item}}</button>
      </span>
      <div *ngIf="showArray[i]" class="buttons-i">
        <span *ngFor="let configItem of batchKeyDetails">
          <ng-container *ngIf="item == configItem.track">
            <span (click)="configPopUpEdit($event, configItem)" style="display: inline-block; margin-right:32px;">
              <mat-checkbox [checked]="configItem.saveStatus" [disableRipple]="true" (click)="$event.preventDefault()">
                <span mat-button>{{configItem.application}}</span>
              </mat-checkbox>
            </span>
          </ng-container>
        </span>
      </div>
    </div>


  </div>
</div>
